/**
 * LE REGISTRE DES AIDES — une entrée par module qui a une aide contextuelle.
 * Sert à l'Administration (libellé lisible d'un écran signalé) ; chaque module importe directement la sienne.
 */
import stage from './stage';
import soutenance from './soutenance';
import planning from './planning';

export const AIDES = { stage, soutenance, planning };

/** « stagiaires/tableau » → « Stagiaires › Tableau de bord » (la clé brute si le module ou l'écran est inconnu). */
export function libelleEcran(module, cle) {
    const a = AIDES[module];
    if (!a) return cle;
    const g = String(cle).split('/')[0];
    const grp = a.GROUPES[g] || g;
    const e = a.ECRANS.find((x) => x.cle === cle);
    return e && e.libelle !== grp ? `${grp} › ${e.libelle}` : (e ? grp : cle);
}
